import {FormField} from "../validation/FormField";

export default class FormHelper {
	static isStringFormFieldEmpty(formField: FormField<string>) {
		return formField.getOptionalValue().map(v => !v.trim().length).getOrElse(true);
	}
}
